import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=01cf0a66&scoped=true&"
import script from "./js/event-item.js?vue&type=script&lang=js&"
export * from "./js/event-item.js?vue&type=script&lang=js&"
import style0 from "./EventItem.vue?vue&type=style&index=0&id=01cf0a66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cf0a66",
  null
  
)

export default component.exports